module.exports = __webpack_public_path__ + "static/img/aw.47ea7038.svg";